import SelectFilterModal from './SelectFilterModal'
import useMiastoFilterModal from '../hooks/useMiastoFilterModal'

export default function MiastoFilterModal({
	isOpen,
	onClose,
	selectedMiastoId,
	idGmina = null,
	idPowiat = null,
	idWojewodztwo = null,
	onApply,
	title = 'Filtruj po miescie',
	description = 'Wybierz miasto, aby zawezic liste placowek.',
	applyLabel = 'Zastosuj',
	clearLabel = 'Wyczysc filtr',
}) {
	const state = useMiastoFilterModal(isOpen, selectedMiastoId, idGmina, idPowiat, idWojewodztwo)
	return (
		<SelectFilterModal
			isOpen={isOpen}
			onClose={onClose}
			onApply={onApply}
			title={title}
			description={description}
			placeholder="Szukaj miasta po nazwie..."
			emptyMessage="Nie znaleziono miast"
			applyLabel={applyLabel}
			clearLabel={clearLabel}
			{...state}
		/>
	)
}
